module.exports = __webpack_public_path__ + "img/V-R-2-load-connect-shadow.6db507f0.png";